import { ContentState } from "draft-js";
import { I18n } from "@assets/strings";
import React from "react";
import { ClipLoader } from "react-spinners";
import { GroupType } from "@domain/group/group";
import { GroupDraft } from "@domain/group/groupDraft";
import { useGroup } from "@domain/group/hooks";
import { Page } from "@ui/components/page";
import { NotFoundPage } from "@ui/pages/notFoundPage";
import { GroupEditor } from "./groupEditor";

interface GroupEditorPageProps extends React.HTMLAttributes<HTMLDivElement> {
	groupId?: string;
	type: GroupType;
	organizationId?: string;
}
export const GroupEditorPage: React.FC<GroupEditorPageProps> = ({ groupId, type, organizationId, ...htmlProps }) =>
	groupId ? (
		<GroupUpdatePage groupId={groupId} {...htmlProps} />
	) : (
		<GroupCreationPage organizationId={organizationId} type={type} {...htmlProps} />
	);

interface GroupUpdatePageProps extends React.HTMLAttributes<HTMLDivElement> {
	groupId: string;
}
const GroupUpdatePage: React.FC<GroupUpdatePageProps> = ({ groupId, ...htmlProps }) => {
	const { result: group, loading, error } = useGroup(groupId);

	if (error?.code === 404) {
		return <NotFoundPage message={I18n.t("404.quiz")} />;
	}

	return (
		<Page {...htmlProps} header={I18n.t("quiz.editor.header")}>
			{loading ? <ClipLoader /> : group && <GroupEditor initialGroup={group} groupId={groupId} />}
		</Page>
	);
};

interface GroupCreatePageProps extends React.HTMLAttributes<HTMLDivElement> {
	type: GroupType;
	organizationId?: string;
}
const GroupCreationPage: React.FC<GroupCreatePageProps> = ({ type, organizationId, ...htmlProps }) => {
	const initialGroup: GroupDraft = {
		type: type,
		name: "",
		description: "",
		categories: [],
		visibility: "PUBLIC",
		accessMode: type === "SHAREROOM" ? "ADMIN_CONSENT" : "OPEN",
		rules: ContentState.createFromText(""),
		subscriptionMode: "MONTHLY",
		price: 0,
		currency: "CHF",
	};

	return (
		<Page {...htmlProps}>
			<GroupEditor organizationId={organizationId} initialGroup={initialGroup} />
		</Page>
	);
};
